import { GalleryHorizontal } from 'lucide-react';
import type { CarouselBlock } from '@impact/types';
import type { BlockTypeConfig } from '../types';

export const carouselConfig: BlockTypeConfig<CarouselBlock> = {
  type: 'carousel',
  label: 'Carousel',
  description: 'Slide-based image carousel with optional CTAs',
  icon: GalleryHorizontal,
  category: 'media',
  createDefault: () => ({
    slides: [
      { id: crypto.randomUUID(), imageUrl: '', alt: '' },
      { id: crypto.randomUUID(), imageUrl: '', alt: '' },
    ],
    height: 'md',
    showDots: true,
    showArrows: true,
  }),
  toolbar: [
    {
      kind: 'select',
      path: 'data.height',
      label: 'Height',
      options: [
        { value: 'sm', label: 'Small' },
        { value: 'md', label: 'Medium' },
        { value: 'lg', label: 'Large' },
        { value: 'xl', label: 'Extra Large' },
      ],
    },
    { kind: 'variant' },
    { kind: 'divider' },
    { kind: 'more' },
  ],
  sheet: [
    { kind: 'toggle', path: 'data.autoplay', label: 'Autoplay' },
    { kind: 'toggle', path: 'data.showDots', label: 'Show dots' },
    { kind: 'toggle', path: 'data.showArrows', label: 'Show arrows' },
    {
      kind: 'number',
      path: 'data.intervalMs',
      label: 'Autoplay interval (ms)',
      min: 1000,
      max: 10000,
    },
  ],
  repeatingItems: {
    arrayPath: 'data.slides',
    itemFactory: () => ({ id: crypto.randomUUID(), imageUrl: '', alt: '' }),
    addLabel: 'Add slide',
  },
};
